module.exports = __webpack_public_path__ + "img/chinesebridge_logo.e567da49.png";